import { callFirebaseFunction, db, storage } from 'boot/firebase';
import { collection } from 'firebase/firestore';
import { deleteObject, ref } from 'firebase/storage';

import GenericDB from './generic-db';

export default class SessionFilesDB extends GenericDB {
  constructor(sessionId = null) {
    super('', 'session.sessionFiles');
    this.setSessionId(sessionId);
  }

  setSessionId(sessionId) {
    this.sessionId = sessionId;
  }

  getCollectionRef() {
    return collection(db, 'sessions', this.sessionId, 'sessionFiles');
  }

  // eslint-disable-next-line class-methods-use-this
  async deleteSessionFile(file) {
    const sessionId = file.session;
    const storagePrefix = `sessions/${sessionId}`;

    const deletePromises = [];

    const fileRef = ref(storage, `${storagePrefix}/${file.originalFilename}`);

    // delete all files after transcoding
    if (file.type === 'application/x-mpegURL' && file.status !== 'failed') {
      const {
        originalFilename,
        downloadFilename,
        mediaFolder,
      } = file;

      // remove the whole folder with m3u8, ts files and coverphoto
      if (mediaFolder) {
        deletePromises.push(callFirebaseFunction('deleteStorageDirectory', {
          prefix: `${storagePrefix}/${mediaFolder}/`,
        }));
      }

      if (downloadFilename && originalFilename !== downloadFilename) {
        const downloadFileRef = ref(storage, `${storagePrefix}/${downloadFilename}`);
        deletePromises.push(deleteObject(downloadFileRef));
      }
    } else {
      deletePromises.push(deleteObject(fileRef));
    }

    return Promise.all(deletePromises);
  }
}
